/* eslint-disable */
import { connect } from 'react-redux';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../../Modals/BaseModal';
import { Button } from '@/Components/ui/button';
import cp from '../../../Images/cp.png';
import cpk from '../../../Images/cpk.png';
import formula1 from '../../../Images/formula1.png';
import formula2 from '../../../Images/formula2.png';

const InfoModal = (props) => {
	const {
		show, toggleModal, data
	} = props;

	const handleClose = () => {
		toggleModal(false);
	};
	const renderBtns = () => {
		return (
            <div className='mx-auto p-1 w-[90%] flex justify-end'>
				<Button variant='default' className='w-[100px] px-4 py-2' onClick={handleClose}>OK</Button>
            </div>
		);
	};

	return (
		<BaseModal
			heading=''
			open={show}
			handleClose={handleClose}
			renderBtns={renderBtns}
			width='40rem'
			height='44rem'
		>
			<div className='flex flex-col justify-start gap-4 p-3 '>
				<h2 className='text-lg font-semibold text-left'>Statistical Analysis Information</h2>
				<p className='text-sm text-gray-600 text-left'>
					This tool can used to study process capability of your systems though data
					measured on UV platform and create graphs for comparison.
				</p>
				
					<div className='flex flex-row gap-3'>
						<div className='w-1/2'>
							<img src={cp} alt='CP/PP graph' className='w-full h-auto' />
						</div>
						<div className='flex flex-col gap-3 w-1/2'>
                             <h3 className='text-start font-bold text-lg'>CP/PP</h3>
							<p className='text-sm mb-2 text-start'>Measures actual capability by calculating spread of the process.</p>
                            <img src={formula1} alt='formula' className='w-[80%] h-auto' />
						</div>
					</div>
				
					<div className='flex flex-row gap-3'>
						<div className='w-1/2 '>
							<img src={cpk} alt='CPK/PPK graph' className='w-full h-auto' />
						</div>
						<div className='flex flex-col gap-3 w-1/2'>
                            <h3 className='text-start font-bold text-lg'>CPK/PPK</h3>
							<p className='text-sm mb-2 text-start'>The minimum distance of the mean from closest process recommended limit.</p>
                                <img src={formula2} alt='formula' className='w-[80%] h-auto' />
						</div>
					</div>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.infoModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleInfoModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);
